module.exports = __webpack_public_path__ + "img/user.47a28f5a.svg";